/*----- Core -----*/
import { storage } from '../../Firebase'

/*----- Components -----*/
import Notification from '../../components/commons/Notification'

/*----- Export -----*/
async function uploadImageAsPromise (image, path) {

	return new Promise(function (resolve, reject) {

		const isImage             = image.match(/image.*/)
		const baseWithoutDataType = image.split(',')[1]

		const storageRef = storage().ref(path)
		const uploadTask = storageRef.putString(isImage? image : baseWithoutDataType, isImage? 'data_url' : 'base64')
		
		// Listen for state changes, errors, and completion of the upload.
		uploadTask.on(storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
		function(snapshot) {
			// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
			var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
			console.log('Upload is ' + progress + '% done')
			switch (snapshot.state) {
				case storage.TaskEvent.PAUSED: // or 'paused'
					console.log('Upload is paused')
					break;
				case storage.TaskEvent.RUNNING: // or 'running'
					console.log('Upload is running')
					break;
				default:	
				}	
			}, function(error) {
				// A full list of error codes is available at
				switch (error.code) {
					case 'storage/unauthorized':
							Notification("User doesn't have permission to access the object", 'error')
						break
					case 'storage/canceled':
							Notification("User canceled the upload", 'error')
						break
						case 'storage/unknown':
							Notification("Unknown error occurred, inspect error.serverResponse", 'error')
						break
					default:	
				}
				reject(error)
				console.log(error)
		}, function() {
			// Upload completed successfully, now we can get the download URL
			uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
				resolve(downloadURL)
			})
		})
	})
}
export default uploadImageAsPromise